import { render, staticRenderFns } from "./input-text.vue?vue&type=template&id=268ab932&scoped=true&"
import script from "./input-text.vue?vue&type=script&lang=js&"
export * from "./input-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268ab932",
  null
  
)

export default component.exports